import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';

const POSITIONS = ['Ketua', 'Wakil Ketua', 'Pengurus', 'Anggota'];

export default function Members() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orderEdit, setOrderEdit] = useState({});

  const fetchMembers = async () => {
    setLoading(true);
    try {
      const res = await api.get('/member-auth/admin/all');
      setMembers(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  const updateMember = async (id, changes) => {
    try {
      await api.put(`/member-auth/admin/${id}`, changes);
      fetchMembers();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update member');
    }
  };

  const saveHomepageOrder = async (id) => {
    const val = orderEdit[id];
    try {
      await api.put(`/member-auth/admin/${id}`, {
        homepage_order: val === '' || val === undefined ? null : parseInt(val, 10),
      });
      fetchMembers();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update urutan');
    }
  };

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Kelola Member</h1>
      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : (
        <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, overflowX: 'auto' }}>
          <table style={{ width: '100%', minWidth: 700, borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #262b33', textAlign: 'left' }}>
                <th style={{ padding: 12, color: '#8B92A0' }}>Nama</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Email</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Posisi</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Approved</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Status</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Urutan Beranda</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Hotspot</th>
                <th style={{ padding: 12, color: '#8B92A0' }}>Profil</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.id} style={{ borderBottom: '1px solid #20242c' }}>
                  <td style={{ padding: 12, fontWeight: 700 }}>{m.name}</td>
                  <td style={{ padding: 12, color: '#8B92A0' }}>{m.email}</td>
                  <td style={{ padding: 12 }}>
                    <select
                      value={m.position}
                      onChange={(e) => updateMember(m.id, { position: e.target.value })}
                      style={{ background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '5px 8px', borderRadius: 4, fontSize: 12 }}
                    >
                      {POSITIONS.map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </select>
                  </td>
                  <td style={{ padding: 12 }}>
                    <button
                      onClick={() => updateMember(m.id, { approved: !m.approved })}
                      style={{
                        background: m.approved ? 'rgba(74,222,128,0.15)' : 'rgba(139,146,160,0.15)',
                        color: m.approved ? '#4ADE80' : '#8B92A0',
                        border: 'none', padding: '5px 12px', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer',
                      }}
                    >
                      {m.approved ? '✓ Approved' : 'Belum'}
                    </button>
                  </td>
                  <td style={{ padding: 12 }}>
                    <button
                      onClick={() => updateMember(m.id, { status: m.status === 'active' ? 'suspended' : 'active' })}
                      style={{
                        background: m.status === 'active' ? 'rgba(43,105,150,0.15)' : 'rgba(208,33,39,0.15)',
                        color: m.status === 'active' ? '#2B6996' : '#D02127',
                        border: 'none', padding: '5px 12px', borderRadius: 4, fontSize: 11, fontWeight: 700, cursor: 'pointer',
                      }}
                    >
                      {m.status}
                    </button>
                  </td>
                  <td style={{ padding: 12 }}>
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      <input
                        type="number"
                        min="1"
                        placeholder="-"
                        defaultValue={m.homepage_order || ''}
                        onChange={(e) => setOrderEdit((prev) => ({ ...prev, [m.id]: e.target.value }))}
                        style={{ width: 50, background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '4px 6px', borderRadius: 4, fontSize: 11 }}
                      />
                      <button
                        onClick={() => saveHomepageOrder(m.id)}
                        style={{ background: 'rgba(43,105,150,0.15)', color: '#2B6996', border: 'none', padding: '4px 8px', borderRadius: 4, fontSize: 10, cursor: 'pointer' }}
                      >
                        Set
                      </button>
                    </div>
                  </td>
                  <td style={{ padding: 12 }}>
                    <Link
                      to={`/members/${m.id}/hotspot`}
                      style={{
                        display: 'inline-block', background: 'rgba(208,33,39,0.15)', color: '#D02127',
                        padding: '5px 12px', borderRadius: 4, fontSize: 11, fontWeight: 700, textDecoration: 'none',
                      }}
                    >
                      Atur Hotspot
                    </Link>
                  </td>
                  <td style={{ padding: 12 }}>
                    <Link
                      to={`/members/${m.id}/edit-profile`}
                      style={{
                        display: 'inline-block', background: 'rgba(43,105,150,0.15)', color: '#2B6996',
                        padding: '5px 12px', borderRadius: 4, fontSize: 11, fontWeight: 700, textDecoration: 'none',
                      }}
                    >
                      Edit Profil
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
